import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { navigate, Link } from "@reach/router";
import FontAwesome from "react-fontawesome";
import {
	doMusicSearch,
	setCurrentTrack,
	clearAdvancedTrackData,
	doAdvancedMusicSearch
} from "../store/actions";

const StyledContentCardAvatar = styled.div`
  border solid 3px #340810;
  border-radius: 5px;
  align-items: center;
  align-text: center;
  justify-content: center;
  line-height: 5rem;
  display: flex;
  position: relative;
  &:after {
    content: "";
    background-color: black;
    background-image: url("${props => props.sc.url}");
    background-repeat: no-repeat;
    background-size: cover;
    opacity: 1;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: -1;
  }
`;

const StyledContentCard = styled.div`
	display: grid;
	grid-template-columns: 1fr 3fr;
	grid-template-rows: minmax(max-content, max-content);
	align-items: center;
`;

const StyledContentCardContent = styled.div`
	background-color: black;
	border-radius: 5px;
	margin: 8px;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-items: stretch;
	align-items: flex-start;
	font-family: "Open Sans";
	overflow: hidden;
`;

const StyledContentTextHeader = styled.h2`
	margin-top: 0px;
	margin-bottom: 0px;
	display: block;
	width: 100%;
	flex: auto;
	font-weight: bold;
	font-size: 1.25rem;
	font-family: "Open Sans";
	text-overflow: ellipsis;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	color: rgba(255, 255, 255, 0.87);
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}
`;

const StyledContentTextArtist = styled.h3`
	margin-top: 0px;
	margin-bottom: 0px;
	display: block;
	width: 100%;
	flex: auto;
	font-size: 0.85rem;
	font-family: "Open Sans";
	font-weight: bold;
	letter-spacing: -0.2px;
	text-overflow: ellipsis;
	text-align: left;
	white-space: nowrap;
	overflow: hidden;
	> strong {
		color: #580f0f;
	}
`;

const StyledContentTextMiddle = styled.div`
	margin-top: 0px;
	margin-bottom: 0px;
	display: block;
	flex: auto;
	font-size: 1rem;
	font-family: "Open Sans";
	font-weight: 300;
	> strong {
		color: #580f0f;
		margin-right: 0.5rem;
		margin-left: 0.5rem;
	}
`;

const ScoreLyricalContainer = styled.div`
	justify-self: start;
	margin-top: 0px;
	margin-bottom: 0px;
	flex: auto;
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	line-height: 0px;
	font-size: 0.7em;
	align-items: center;
	height: 22.5px;
`;

const ScoreAndLyricalCards = styled.p`
	flex: 1 1 auto;
	height: inherit;
	margin-right: 5px;
	margin-top: 0px;
	margin-bottom: 0px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: rgba(255, 255, 255, 0.87);
	font-family: "Open Sans";
	font-size: 12px;
	font-weight: 300;
	background-color: #c21e3d;
	border: 0px solid transparent;
	border-radius: 12.5px 12.5px 12.5px 12.5px;
	opacity: 1;
`;

const OpaqueSpan = styled.span`
	opacity: 0.75;
`;

const PlayIcon = styled(FontAwesome)`
	font-size: 2rem;
	line-height: 5rem;
	padding-right: 2rem;
	padding-left: 2rem;
	transition: all 0.5s;
	&:hover {
		cursor: pointer;
		opacity: 0.5;
	}
`;

class MusicContentCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			playing: "white",
			playPauseIcon: "far fa-play",
			songProgress: 0,
			intervals: []
		};
	}

	_highlightIcon = color => {
		this.setState({ playing: color });
	};

	_passBackTrack = async () => {
		const { item } = this.props;
		console.log("MusicContentCard Component:->_passBackTrack", item);

		const isNew = await this.props.player.setCurrentTrack(item);
		if (isNew) {
			console.log("MusicContentCard Component:->_passBackTrack: New track");
			this.props.player.playAudio();
		} else {
			console.log("MusicContentCard Component:->_passBackTrack: Current track");
			this.props.player.pausePlayAudio();
		}
	};

	_passBackTrackNavigateToTrack = async () => {
		// this.props.passTrack(this.props.item);
		const { item, music } = this.props;
		let itemID;
		if (item.hasOwnProperty("uniqueId")) {
			itemID = item.uniqueId;
		} else {
			itemID = item.id;
		}
		console.log(
			"Navigating to current track?",
			item.id === music.audioPlayerState.trackID,
			item.id,
			music.audioPlayerState.trackID
		);
		const trackInfo = {
			trackID: itemID,
			playPause: "play",
			showFooterPlayer: item.id === music.audioPlayerState.trackID,
			songSrc: item.preview_url,
			componentPlaying: "track",
			item
		};
		const a = music.audioPlayerState.domRef();
		if (a.paused && item.id !== music.audioPlayerState.trackID) {
			a.pause();
		}
		this.props.player.clearAdvancedTrackData();
		this.props.player.setCurrentTrack(item);
		console.log("MusicContentCard->_passBackTrackNavigateToTrack", item);
		this.props.player.updateAudio(trackInfo);
		await this.props.doAdvancedMusicSearch();
		navigate(`/track?id=${item.id}`);
	};

	// SHOWS THE CUE SCORE AND LYRIC SCORE OF A TRACK IF EXIST.
	showAdvancedTrackInfo = () => {
		return (
			<React.Fragment>
				<ScoreAndLyricalCards>
					{this.props.item && this.props.item.cue_score ? (
						<span>
							<strong>{`${this.props.item.cue_score}%`}&nbsp;</strong>
							<OpaqueSpan>cue</OpaqueSpan>
						</span>
					) : (
						<span>
							<strong>0%&nbsp;</strong>
							<OpaqueSpan>cue</OpaqueSpan>
						</span>
					)}
				</ScoreAndLyricalCards>
				<ScoreAndLyricalCards>
					{this.props.item && this.props.item.lyric_score ? (
						<span>
							<strong>{`${this.props.item.lyric_score}%`}&nbsp;</strong>
							<OpaqueSpan>lyrical</OpaqueSpan>
						</span>
					) : (
						<span>
							<strong>0%&nbsp;</strong>
							<OpaqueSpan>lyrical</OpaqueSpan>
						</span>
					)}
				</ScoreAndLyricalCards>
			</React.Fragment>
		);
	};

	_checkIconColor = () => {
		const { trackID } = this.props.music.audioPlayerState;
		const { item } = this.props;
		if (trackID === item.id) {
			return "red";
		}
		return "white";
	};

	_renderArtistLinks(artist) {
		const artists = artist.split(",");
		return artists.map((name, index) => (
			<Link to={"/?s=" + name} key={name}>
				{name}
				{index < artists.length - 1 ? "," : ""}
			</Link>
		));
	}

	render() {
		const { trackID } = this.props.music.audioPlayerState;
		const { footerPlayerPaused, showAdvancedData } = this.props.music;
		const { item } = this.props;

		let shortName = item.title;
		let shortArtistName = item.artist;
		if (shortName.length > 25) {
			shortName = shortName.substring(0, 25).trim();
			shortName += "...";
		}
		if (shortArtistName.length > 25) {
			shortArtistName = shortArtistName.substring(0, 25).trim();
			shortArtistName += "...";
		}
		return (
			<StyledContentCard
				style={{
					height: showAdvancedData ? "120px" : "100px"
				}}>
				<StyledContentCardAvatar
					style={{
						height: "100px",
						width: "100px"
					}}
					sc={{
						url: item
							? item.album.thumbnail
								? item.album.thumbnail[0].url
								: null
							: null
					}}>
					{item
						? item.preview_url && (
								<PlayIcon
									name={
										this.state.songProgress === 100
											? "far fa-play"
											: (trackID !== item.id && trackID !== item.uniqueId) ||
											  footerPlayerPaused
											? "far fa-play"
											: "fas fa-pause"
									}
									onClick={this._passBackTrack}
									style={{
										color: this._checkIconColor()
									}}
								/>
						  )
						: null}
				</StyledContentCardAvatar>
				<StyledContentCardContent
					style={{
						height: showAdvancedData ? "110px" : "100px"
					}}>
					<StyledContentTextHeader
						onClick={this._passBackTrackNavigateToTrack}
						style={{
							justifySelf: "start"
						}}>
						{item.title}
					</StyledContentTextHeader>
					<StyledContentTextArtist
						style={{
							justifySelf: "start"
						}}>
						<strong>by:</strong>
						{this._renderArtistLinks(item.artist)}
					</StyledContentTextArtist>
					<StyledContentTextMiddle
						style={{
							justifySelf: "start",
							width: "100%"
						}}>
						<OpaqueSpan>{item && `${item.camelot}`}</OpaqueSpan>
						<strong>&bull;</strong>
						<OpaqueSpan>{item && `${item.key}`}</OpaqueSpan>
						<strong>&bull;</strong>{" "}
						<OpaqueSpan>
							{item &&
								`${Math.round(item.features ? item.features.energy : 0)} BPM`}
						</OpaqueSpan>
					</StyledContentTextMiddle>
					{/* <StyledContentTextBottom>{item && `${item.duration} min`}</StyledContentTextBottom> */}
					<ScoreLyricalContainer
						style={{
							flex: "1 0 23px",
							width: "100%"
						}}>
						{showAdvancedData && this.showAdvancedTrackInfo()}
					</ScoreLyricalContainer>
				</StyledContentCardContent>
			</StyledContentCard>
		);
	}
}

const mapStateToProps = state => ({ music: state.music });

export default connect(
	mapStateToProps,
	{
		doMusicSearch,
		setCurrentTrack,
		clearAdvancedTrackData,
		doAdvancedMusicSearch
	}
)(MusicContentCard);



// WEBPACK FOOTER //
// ./src/components/MusicContentCard.js